import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorAccentLinkLight, colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const DidYouMeanLinkStyled = styled(Link) `
  text-decoration: none;
  color: ${colorAccentLinkLight};
`;
export const NoResultsMessageStyled = styled(RegularTextLevel3) `
  span {
    color: ${colorCoreBlack300};
  }
`;
